import { RadioGroup } from 'entities/RadioGroup'
import { useConfigStore } from 'shared/store/configSlice'

export const PaymentOrderSelector = () => {
  const updateMenuConfig = useConfigStore().updateMenuConfig
  const config = useConfigStore().config?.menuConfig

  const handlePaymentProvider = (value: string | number) => {
    updateMenuConfig({
      paymentVariant: Number(value) as 1 | 2,
      selfService: Number(value) === 2 ? 0 : config?.QRMENU?.selfService
    })
  }

  return (
    <RadioGroup
      isRow
      value={config?.QRMENU?.paymentVariant || 0}
      handleChange={handlePaymentProvider}
      options={PaymentOrderOptions}
      title='Payment variant'
    />
  )
}

const PaymentOrderOptions = [
  {
    value: 1,
    label: 'After booking'
  },
  {
    value: 2,
    label: 'After meal'
  }
]
